<template lang="pug">
.Box-notice._mb2._flex._flex-alignItemsCenter._flex-justifySpaceBetween._radius._px075._py05(v-if="!state.maker.data.isEmailVerified") 
   ._fs-075._mr1._lineHeight--1dot4._pr05 Please verify your email “{{state.maker.data.email}}” (we've sent you an email for this)
   //- btn or resent note
   button._relative.Btn.Btn--white._fs-05._px075._py05._fw-normal._noWrap(v-if="!successOrError && !$root.verificationEmailResent" v-on:click="resendConfirmationEmail") 
      | Resend verification email
      Loading(v-if="isResending" iconSize="20px")
   ._fs-075._c-green-800._semiBold(v-if="!isResending && success || $root.verificationEmailResent") Verification link resent!
   ._fs-075._c-red-800._semiBold(v-if="!isResending && error") Error resending
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'

export default {
   data() {
      return {
         isResending: false,
         successOrError: false,
         success: false,
         error: false,
         state: this.$store.state,
      }
   },
   methods: {
      resendConfirmationEmail() {
         this.isResending = true
         return this.$store
            .dispatch('resendEmailVerificationEmail', this.state.maker.data.email)
            .then(response => {
               console.log('response from lambda api endpoint: ', response)
            })
            .then(() => {
               this.success = true
            })
            .catch(() => {
               this.error = true
            })
            .finally(() => {
               this.successOrError = true
               this.isResending = false
               this.$root.verificationEmailResent = true
            })
      },
   },
}
</script>
